---
title: Тариф, додатки та рахунки
parent: Документація
parentHref: /docs
---

<script>
  import DomainTlds from "@/components/domain-tlds.svelte"
</script>

# Тариф, додатки, рахунки та юридичні сторінки

## Один тариф з усім включеним

TOBY має один повний тариф без плати за налаштування та без прихованих рівнів:

- **Щомісячна або річна оплата:** Обирайте гнучку щомісячну оплату (можна скасувати щомісяця в будь-який час) або вигіднішу річну оплату (також можна оплатити за рахунком). Актуальні ціни дивіться у [прайс-листі](/uk/pricing).

Кожна підписка включає:

- **Ваш власний домен** (<DomainTlds />) — включно з перенесенням існуючого домену (Domain-Umzug)
- **1 адресу електронної пошти** (info@...) з **поштовою скринькою 15 ГБ (Maxi-Postfach)** та необмеженою кількістю адрес пересилання
- **До 15 сторінок** — створених та підтримуваних через чат, голос або завантаження фотографій
- **1 додаткову мову** (всього 2 мови) з автоматичним перекладом при публікації
- **Розсилка новин** з **1 000 електронних листів / місяць**
- **Аналітика відвідувачів** (з дотриманням конфіденційності, без банерів про файли cookie)
- **Стартовий пакет поштою** (наклейка на двері та QR-підставка формату А5 для столу)
- **Хостинг у ЄС** з автоматичним захистом SSL

## Додаткові опції

Якщо Ваш бізнес виросте за межі включених лімітів, Ви можете в будь-який час додати гнучкі модулі в розділі **Налаштування → Підписка** (можна скасувати щомісяця, див. [прайс-лист](/uk/pricing)):

- **+15 ГБ сховища електронної пошти** (або додаткова поштова скринька)
- **+1 додаткова мова вебсайту**
- **+15 додаткових сторінок**
- **+5 000 електронних листів розсилки новин / місяць**

## Як отримати справжній бізнес-рахунок (Вебсайт проти Google Play)

Якщо Ви ведете бізнес, практику або працюєте як фрілансер і Вам потрібен **справжній рахунок, що вираховується з податків (ordentliche Rechnung)** з назвою Вашої компанії, бізнес-адресою та окремо вказаним ПДВ (MwSt.), зверніть увагу, де Ви оформляєте підписку:

- **Підписка на вебсайті (tobysite.com через Stripe):** Ви завжди отримуєте від нас **справжній бізнес-рахунок з ПДВ**, виписаний на Ваш бізнес. Ви можете завантажити всі попередні рахунки та оновити адресу для виставлення рахунків Вашої компанії в будь-який час у розділі **Налаштування → Підписка**.
- **Підписка в Android-додатку (Покупка через Google Play):** Коли Ви оформляєте підписку через Google Play, Google обробляє платіж як продавець і видає лише стандартну квитанцію про оплату Google Play. **Ми не можемо виставити бізнес-рахунок з ПДВ (ordentliche Rechnung) для підписок, оплачених через Google Play.**

> **Порада:** Ви можете оформити підписку на **tobysite.com** у браузері, щоб отримувати справжні бізнес-рахунки Stripe, і все одно використовувати додатки TOBY для Android та iOS з Вашим обліковим записом без додаткових витрат.

## Додавання Вашого Імпресуму (Impressum) та Політики конфіденційності (Datenschutz)

- **Ваш власний юридичний текст:** Оскільки юридичні вимоги залежать від структури Вашого бізнесу, професії та країни, **TOBY не генерує юридичних консультацій і не пише юридичні тексти (Impressum або Datenschutzerklärung) самостійно.**
- **Як їх додати:** Просто вставте існуючий текст Вашого Імпресуму або Політики конфіденційності в чат (або завантажте його як документ Word/PDF, або попросіть TOBY скопіювати його з Вашого старого вебсайту) і скажіть *"Розмістіть це на нашій сторінці Імпресум."* TOBY створить сторінки та охайно розмістить посилання на них у футері Вашого вебсайту.
